export const TypesDetalheGate = {
    DETALHEGATE: "DETALHEGATE",
    RESETDETALHEGATE: "RESETDETALHEGATE",
}

const INITIAL = {
    gateId: 0,
}

export default function detalheGateReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesDetalheGate.DETALHEGATE:
            return {
                ...state,
                gateId: action.payload.gateId
            };
        case TypesDetalheGate.RESETDETALHEGATE:
            return INITIAL;
        default:
            return state;
    }
}

export const DetalheGateActions = {
    detalheGate,
    resetStateDetalheGate,
}

function detalheGate(pgateId) {

    return {
        type: TypesDetalheGate.DETALHEGATE,
        payload: { gateId: pgateId }
    }
}

function resetStateDetalheGate() {
    return { type: "RESETDETALHEGATE" }
}